import { useState } from "react";
import {
  Box,
  Divider,
  Group,
  Text,
  ActionIcon,
  Collapse,
  Tooltip,
} from "@mantine/core";
import {
  IconChevronDown,
  IconChevronUp,
  IconArrowRight,
} from "@tabler/icons-react";

interface RightPanelWidgetProps {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  onOpen?: () => void;
  badge?: React.ReactNode;
}

export function RightPanelWidget({
  title,
  icon,
  children,
  defaultExpanded = true,
  onOpen,
  badge,
}: RightPanelWidgetProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Box px="md">
      <Group
        justify="space-between"
        style={{ cursor: "pointer" }}
        onClick={() => setExpanded(!expanded)}
        mb={expanded ? "sm" : 0}
        wrap="nowrap"
      >
        <Group gap="xs" wrap="nowrap" style={{ flex: 1, minWidth: 0 }}>
          {icon}
          <Text size="sm" fw={600} truncate>
            {title}
          </Text>
          {badge}
        </Group>
        <Group gap={2} wrap="nowrap">
          {onOpen && (
            <Tooltip label={`Open ${title}`} withArrow>
              <ActionIcon
                variant="subtle"
                size="sm"
                color="blue"
                onClick={(e) => {
                  e.stopPropagation();
                  onOpen();
                }}
              >
                <IconArrowRight size={13} />
              </ActionIcon>
            </Tooltip>
          )}
          <ActionIcon variant="subtle" size="sm">
            {expanded ? (
              <IconChevronUp size={14} />
            ) : (
              <IconChevronDown size={14} />
            )}
          </ActionIcon>
        </Group>
      </Group>
      <Collapse in={expanded}>{children}</Collapse>
      <Divider mt="sm" mb="sm" mx="-md" />
    </Box>
  );
}
